var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("settings.workflow.title")))]),
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-tabs",
            {
              staticClass: "sub-menu md-3",
              attrs: { "slider-color": "primary" }
            },
            [
              _c(
                "v-tab",
                { key: "delegation-order", staticClass: "sub-menu-item" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("settings.workflow.delegationOrder")) +
                      " "
                  )
                ]
              ),
              _c("v-tab", { key: "delegation", staticClass: "sub-menu-item" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("settings.workflow.delegation")) + " "
                )
              ]),
              _c(
                "v-tab-item",
                { key: "delegation-order", staticClass: "mt-2" },
                [
                  _c("workflow", {
                    attrs: { "workflow-data": _vm.delegationOrderWorkflowData },
                    on: {
                      "update:workflowData": function($event) {
                        _vm.delegationOrderWorkflowData = $event
                      },
                      "update:workflow-data": function($event) {
                        _vm.delegationOrderWorkflowData = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                { key: "delegation", staticClass: "mt-2" },
                [
                  _c("workflow", {
                    attrs: { "workflow-data": _vm.delegationWorkflowData },
                    on: {
                      "update:workflowData": function($event) {
                        _vm.delegationWorkflowData = $event
                      },
                      "update:workflow-data": function($event) {
                        _vm.delegationWorkflowData = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          staticClass: "success",
          on: { click: _vm.saveDelegationOrderWorkflowSettings }
        },
        [_vm._v(_vm._s(_vm.$t("global.save")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }